module.exports = __webpack_public_path__ + "img/theCards.4af6a981.svg";